import { useCallback } from "react";
import axios from "axios";
import { useAuth } from "@clerk/react";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function useApi() {
  const { getToken } = useAuth();
  return useCallback(
    async (method, path, data) => {
      const token = await getToken();
      const res = await axios({ method, url: `${API}${path}`, data, headers: { Authorization: `Bearer ${token}` } });
      return res.data;
    },
    [getToken]
  );
}

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (Array.isArray(d)) return "Veuillez vérifier les champs du formulaire.";
  return d || "Une erreur est survenue.";
};

export const ROLE_LABELS = {
  super_admin: "Super-administrateur",
  admin: "Administrateur",
  moderator: "Modérateur",
  viewer: "Observateur",
  pending: "En attente",
};

export const fmtDate = (v) => {
  if (!v) return "—";
  const d = new Date(v);
  if (isNaN(d)) return v;
  return d.toLocaleString("fr-FR", { day: "2-digit", month: "short", year: "numeric", ...(v.includes("T") ? { hour: "2-digit", minute: "2-digit" } : {}) });
};
